import { render, staticRenderFns } from "./AiCompanies.vue?vue&type=template&id=38586eda&"
import script from "./AiCompanies.vue?vue&type=script&lang=js&"
export * from "./AiCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports